module.exports = __webpack_public_path__ + "img/photo-2.f3f645bf.jpg";